export default __webpack_public_path__ + "static/media/logout.d13f8bbd.gif";